function SectionPagination({ currentPage, totalItems, itemsPerPage, onPageChange }) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const generatePageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            pages.push(1);
            if (currentPage > 3) pages.push("...");

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) pages.push(i);

            if (currentPage < totalPages - 2) pages.push("...");
            if (currentPage < totalPages) pages.push(totalPages);
        }

        return pages;
    };

    const pages = generatePageNumbers();

    return (
        <div className="pagination-outer">
            <div className="pagination-style1">
                <ul className="clearfix">
                    <li className={`prev ${currentPage === 1 ? "disabled" : ""}`}>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            if (currentPage > 1) onPageChange(currentPage - 1);
                        }}>
                            <span><i className="fa fa-angle-left" /></span>
                        </a>
                    </li>

                    {pages.map((page, idx) => (
                        <li key={idx} className={page === currentPage ? "active" : ""}>
                            <a href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (page !== "...") onPageChange(page);
                                }}
                            >
                                {page}
                            </a>
                        </li>
                    ))}

                    <li className={`next ${currentPage === totalPages ? "disabled" : ""}`}>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            if (currentPage < totalPages) onPageChange(currentPage + 1);
                        }}>
                            <span><i className="fa fa-angle-right" /></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default SectionPagination;



// function SectionPagination() {
//     return (
//         <>
//             <div className="pagination-outer">
//                 <div className="pagination-style1">
//                     <ul className="clearfix">
//                         <li className="prev"><a href="#"><span> <i className="fa fa-angle-left" /> </span></a></li>
//                         <li><a href="#">1</a></li>
//                         <li className="active"><a href="#">2</a></li>
//                         <li><a href="#">3</a></li>
//                         <li><a className="#" href="#"><i className="fa fa-ellipsis-h" /></a></li>
//                         <li><a href="#">5</a></li>
//                         <li className="next"><a href="#"><span> <i className="fa fa-angle-right" /> </span></a></li>
//                     </ul>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default SectionPagination;